const routes = [
    {
        path: "/payment/types",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "paymenttype_index"
        },
        component_full_path: "paymenttypes/pages/Index"
    }
];

export default routes;
